export default (n, m) => ((n % m) + m) % m
